// 路由配置
import Vue from 'vue'
import VueRouter from 'vue-router' //这是基于Vue的一个插件

import Home from "../component/home/Home.vue";
import Pay from "../component/pay/Pay.vue";
import Info from "../component/info/Info.vue";
import EditInfo from "../component/editInfo/EditInfo.vue";
import WeiXinPay from "../component/pay/WeiXinPay.vue";
import AppPay from "../component/pay/AppPay.vue";
import payBack from "../component/pay/payBack.vue";

import Speed from "../component/info/speed/Speed.vue";
import Birthday from "../component/info/birthday/Birthday.vue";
import Interest from "../component/info/Interest/Interest.vue";
import Tele from "../component/info/tele/Tele.vue";

import EditSpeed from "../component/editInfo/speed/Speed.vue";
import EditBirthday from "../component/editInfo/birthday/Birthday.vue";
import EditInterest from "../component/editInfo/Interest/Interest.vue";
import EditTele from "../component/editInfo/tele/Tele.vue";

// slide介绍
import descSlide from "../component/slidePage/index.vue";

// 体验V卡
import VcardTiyan from "../component/Vcard/VcardTiyan.vue";


import Login from "../component/login/loginShop.vue";
import LoginSuccess from "../component/login/loginSuccess.vue";

let news = [
  { name: 'Speed', path: '/info/speed', component: Speed },
  { name: 'Birthday', path: '/info/birthday', component: Birthday },
  { name: 'Interest', path: '/info/interest', component: Interest },
  { name: 'Tele', path: '/info/tele', component: Tele },
]

let editNews = [
  { name: 'EditSpeed', path: '/editInfo/speed', component: EditSpeed },
  { name: 'EditBirthday', path: '/editInfo/birthday', component: EditBirthday },
  { name: 'EditInterest', path: '/editInfo/interest', component: EditInterest },
  { name: 'EditTele', path: '/editInfo/tele', component: EditTele },
]

Vue.use(VueRouter)


let router = new VueRouter({
  routes: [
    { path: '/', redirect: '/home' },
    { path: '/info', redirect: '/info/speed' },
    { path: '/editinfo', redirect: '/editinfo/speed' },
    { path: '/home', component: Home, name: 'V卡会员', meta: { title: 'V卡会员', requireAuth:true } },
    { path: '/pay', component: Pay, name: 'V卡会员支付', meta: { title: 'V卡会员支付', requireAuth: true } },
    { path: '/weiXinpay', component: WeiXinPay },
    { path: '/AppPay', component: AppPay },
    { path: '/payBack', component: payBack },
    { path: '/info', component: Info, children: [...news], meta: { requireAuth: true } },
    { path: '/editinfo', component: EditInfo, children: [...editNews], meta: { requireAuth: true } },
    { path: '/login/loginShop', component: Login },
    { path: '/login/loginSuccess', component: LoginSuccess },
    { path: '/descSlide', component: descSlide },
    { path: '/VcardTiyan', component: VcardTiyan, name: 'V卡会员体验', meta: { title: 'V卡会员体验', requireAuth: true }  },
  ]
})
function get_cookie(Name) {
  var search = Name + "="//查询检索的值
  var returnvalue = "";//返回值
  if (document.cookie.length > 0) {
    var sd = document.cookie.indexOf(search);
    if (sd != -1) {
      sd += search.length;
      var end = document.cookie.indexOf(";", sd);
      if (end == -1)
        end = document.cookie.length;
      returnvalue = unescape(document.cookie.substring(sd, end))
    }
  }
  return returnvalue;
}
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
  // if (to.matched.some(record => record.meta.requireAuth)){
  //   if (!get_cookie('MemberToken')){
  //     // 仿造登陆
  //     // let code = '4d485ef054c94588a92c5eb839cbcf41';// new HttpService().search('membercode');
  //     // document.cookie = "MemberToken=" + code;
  //     // return;
  //     var url = location.href;
  //     localStorage.setItem('gotoUrl', url);
  //     // location.href = 'http://ssovcardtest.sso.gdtvdv.com/api/Login/Login'; //测试登陆接口
  //     location.href = "https://vcard.gdtvdv.com/api/Login/Login" // 正式登陆接口路径
  //   }else{
  //     next()
  //   }
  // }else{
  //   next()
  // }
})


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js